export const KYC_STEPS = {
  MF_DETAILS_LOADING: '1',
  MF_KYC: '2',
  FATCA_FORM: '3',
  FATCA_DECLINED: '4',
  RISK_PROFILE_SELECTION: '5',
  RISK_PROFILE_QUESTIONS: '6',
  RISK_PROFILE_QUESTIONS_SUBMITTING: '7',
  BANK_LINK: '8',
};

export const KYC_MODALS = {
  MF_KYC_CANCEL: 'MF_KYC_CANCEL',
  FATCA_CANCEL: 'FATCA_CANCEL',
  MFL_WARNING: 'MFL_WARNING',
  TRANSACTION_NOT_ALLOWED: 'TRANSACTION_NOT_ALLOWED',
  REGISTRATION_NOT_ALLOWED: 'REGISTRATION_NOT_ALLOWED',
};

export const KYC_MODAL_COMMANDS = {
  CLOSE_MODAL: 'CLOSE_MODAL',
  NAVIGATE_TO_MFL: 'NAVIGATE_TO_MFL',
  NAVIGATE_TO_MFL_NO_MODAL: 'NAVIGATE_TO_MFL_NO_MODAL',
  SHOW_FATCA_DECLINED: 'SHOW_FATCA_DECLINED',
  NAV_TO_SUCCESS_ROUTE: 'NAV_TO_SUCCESS_ROUTE',
};

export const KYC_ERRORS = {
  7040: 'Dear customer, you are not eligible to invest in online Mutual Funds. Please visit your nearest Axis Bank branch or contact your relationship manager.',
  7044: 'Dear Customer, we regret to inform you that as per regulations, online investment is unavailable for customers based in the USA & Canada. Please contact your relationship manager for further details',
  7045: 'We regret to inform you that online investment in mutual funds is only available for individual account holders. Please contact your relationship manager or visit the nearest Axis Bank branch for further details',
  7046: 'Dear Customer, we regret to inform you that minors cannot register online for Mutual Fund investments. Please contact your relationship manager or visit the nearest Axis Bank branch for further information',
  7047: 'Dear Customer, we are unable to process your request as your address is incomplete in our system. You can update your details via Axis Bank’s Internet Banking or Mobile Banking App or visit the nearest Axis Bank branch. Post successful updation you can start investing.',
  7048: 'Dear Customer, as per guidelines, it is mandatory for NRIs to provide an overseas address. As per our records, this information is not updated. Please log in via Internet banking, the Axis Bank Mobile App or contact your relationship manager to update your details.',
  7049: 'Dear Customer, we are unable to process your request as your PAN is not available in our records. Please update the same to continue investing. You can update your details online via Internet Banking or Axis Mobile App. Alternatively, please connect with your relationship manager or visit the nearest Axis Bank branch',
  7051: 'We regret to inform you that online investment in mutual funds is only available for individual account holders. Please contact your relationship manager or visit the nearest Axis Bank branch for further details',
  7055: 'Dear Customer, It seems you are not eligible to invest in online mutual funds. Please contact your relationship manager or visit the nearest Axis Bank branch for further details. Regret the inconvenience.',
  7063: 'Dear Customer, It seems that your Father or Spouse name is not updated in our system. Please update your details through the Axis Mobile App or Internet Banking post which you can return to initiate the transaction. You can also visit your nearest Axis Bank branch. Regret the inconvenience.',
};

export const Country_List = [
  { value: 'IN', label: 'India' },
  { value: 'AF', label: 'Afghanistan' },
  { value: 'AX', label: 'Aland Islands' },
  { value: 'DZ', label: 'Algeria' },
  { value: 'AD', label: 'Andorra' },
  { value: 'AO', label: 'Angola' },
  { value: 'AI', label: 'Anguilla' },
  { value: 'AQ', label: 'Antarctica' },
  { value: 'AG', label: 'Antigua And Barbuda' },
  { value: 'AR', label: 'Argentina' },
  { value: 'AM', label: 'Armenia' },
  { value: 'AW', label: 'Aruba' },
  { value: 'AU', label: 'Australia' },
  { value: 'AT', label: 'Austria' },
  { value: 'AZ', label: 'Azerbaijan' },
  { value: 'BS', label: 'Bahamas' },
  { value: 'BH', label: 'Bahrain' },
  { value: 'BD', label: 'Bangladesh' },
  { value: 'BB', label: 'Barbados' },
  { value: 'BY', label: 'Belarus' },
  { value: 'BE', label: 'Belgium' },
  { value: 'BJ', label: 'Benin' },
  { value: 'BM', label: 'Bermuda' },
  { value: 'BT', label: 'Bhutan' },
  { value: 'BQ', label: 'Bonaire, Sint Eustatius And Saba' },
  { value: 'BW', label: 'Botswana' },
  { value: 'BV', label: 'Bouvet Island' },
  { value: 'BR', label: 'Brazil' },
  { value: 'IO', label: 'British Indian Ocean Territory' },
  { value: 'BG', label: 'Bulgaria' },
  { value: 'BF', label: 'Burkina Faso' },
  { value: 'BI', label: 'Burundi' },
  { value: 'CZ', label: 'CZECH REPUBLIC' },
  { value: 'CM', label: 'Camaroon' },
  { value: 'KH', label: 'Cambodia' },
  // { "value": "CA", "title": "Canada" },
  { value: 'CV', label: 'Cape Verde' },
  { value: 'KY', label: 'Cayman Islands' },
  { value: 'CF', label: 'Central African Republic' },
  { value: 'TD', label: 'Chad' },
  { value: 'CN', label: 'China' },
  { value: 'CX', label: 'Christmas Island' },
  { value: 'CC', label: 'Cocos (Keeling) Islands' },
  { value: 'CO', label: 'Colombia' },
  { value: 'KM', label: 'Comoros' },
  { value: 'CG', label: 'Congo' },
  { value: 'CD', label: 'Congo, The Democratic Republic Of The' },
  { value: 'CK', label: 'Cook Islands' },
  { value: 'HR', label: 'Croatia' },
  { value: 'CU', label: 'Cuba' },
  { value: 'CW', label: 'Curacao' },
  { value: 'CY', label: 'Cyprus' },
  { value: 'DK', label: 'Denmark' },
  { value: 'DJ', label: 'Djibouti' },
  { value: 'DM', label: 'Dominica' },
  { value: 'DO', label: 'Dominican Republic' },
  { value: 'SV', label: 'El Salvador' },
  { value: 'EC', label: 'Equador' },
  { value: 'GQ', label: 'Equatorial Guinea' },
  { value: 'ER', label: 'Eritrea' },
  { value: 'EE', label: 'Estonia' },
  { value: 'ET', label: 'Ethiopia' },
  { value: 'EG', label: 'Eygpt' },
  { value: 'FK', label: 'Falkland Islands (Malvinas)' },
  { value: 'FO', label: 'Faroe Islands' },
  { value: 'FJ', label: 'Fiji' },
  { value: 'FI', label: 'Finland' },
  { value: 'FR', label: 'France' },
  { value: 'GF', label: 'French Guiana' },
  { value: 'PF', label: 'French Polynesia' },
  { value: 'TF', label: 'French Southern Territories' },
  { value: 'GA', label: 'Gabon' },
  { value: 'GM', label: 'Gambia' },
  { value: 'GE', label: 'Georgia' },
  { value: 'DE', label: 'Germany' },
  { value: 'GH', label: 'Ghana                    ' },
  { value: 'GI', label: 'Gibraltar' },
  { value: 'GR', label: 'Greece' },
  { value: 'GL', label: 'Greenland' },
  { value: 'GD', label: 'Grenada' },
  { value: 'GP', label: 'Guadeloupe' },
  { value: 'GU', label: 'Guam' },
  { value: 'GT', label: 'Guatemala' },
  { value: 'GG', label: 'Guernsey' },
  { value: 'GN', label: 'Guinea' },
  { value: 'GW', label: 'Guinea-Bissau' },
  { value: 'GY', label: 'Guyana' },
  { value: 'HT', label: 'Haiti' },
  { value: 'HM', label: 'Heard Island And McDonald Islands' },
  { value: 'HN', label: 'Honduras' },
  { value: 'HK', label: 'Hong Kong' },
  { value: 'HU', label: 'Hungary' },
  { value: 'ID', label: 'Indonesia' },
  { value: 'IR', label: 'Iran' },
  { value: 'IQ', label: 'Iraq' },
  { value: 'IE', label: 'Ireland' },
  { value: 'IM', label: 'Isle Of Man' },
  { value: 'IL', label: 'Israel' },
  { value: 'IT', label: 'Italy' },
  { value: 'JM', label: 'Jamaica' },
  { value: 'JP', label: 'Japan' },
  { value: 'JE', label: 'Jersey' },
  { value: 'JO', label: 'Jordan' },
  { value: 'KE', label: 'Kenya' },
  { value: 'KI', label: 'Kiribati' },
  { value: 'KW', label: 'Kuwait' },
  { value: 'KG', label: 'Kyrgyzstan' },
  { value: 'LA', label: "Lao People's Democratic Republic" },
  { value: 'LV', label: 'Latvia' },
  { value: 'LB', label: 'Lebanon' },
  { value: 'LS', label: 'Lesotho' },
  { value: 'LR', label: 'Liberia' },
  { value: 'LY', label: 'Libyan Arab Jamahiriya' },
  { value: 'LI', label: 'Liechtenstein' },
  { value: 'LT', label: 'Lithuania' },
  { value: 'LU', label: 'Luxembourg' },
  { value: 'MK', label: 'Macedonia, The Former Yugoslav Republic Of' },
  { value: 'MG', label: 'Madagascar' },
  { value: 'MW', label: 'Malawi' },
  { value: 'MY', label: 'Malaysia' },
  { value: 'MV', label: 'Maldives' },
  { value: 'ML', label: 'Mali' },
  { value: 'MT', label: 'Malta' },
  { value: 'MH', label: 'Marshall Islands' },
  { value: 'MQ', label: 'Martinique' },
  { value: 'MR', label: 'Mauritania' },
  { value: 'MU', label: 'Mauritius' },
  { value: 'YT', label: 'Mayotte' },
  { value: 'MX', label: 'Mexico' },
  { value: 'FM', label: 'Micronesia, Federated States Of' },
  { value: 'MC', label: 'Monaco' },
  { value: 'MN', label: 'Mongolia' },
  { value: 'ME', label: 'Montenegro' },
  { value: 'MS', label: 'Montserrat' },
  { value: 'MZ', label: 'Mozambique' },
  { value: 'MM', label: 'Myanmar' },
  { value: 'NA', label: 'Namibia' },
  { value: 'NR', label: 'Nauru' },
  { value: 'NP', label: 'Nepal' },
  { value: 'NL', label: 'Netherlands' },
  { value: 'AN', label: 'Netherlands Antilles' },
  { value: 'NC', label: 'New Caledonia' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'NI', label: 'Nicaragua' },
  { value: 'NG', label: 'Nigeria' },
  { value: 'NU', label: 'Niue' },
  { value: 'NF', label: 'Norfolk Island' },
  { value: 'MP', label: 'Northern Mariana Islands' },
  { value: 'NO', label: 'Norway' },
  { value: 'XX', label: 'Not categorised' },
  { value: 'OM', label: 'Oman' },
  { value: 'ZZ', label: 'Other                    ' },
  { value: 'PK', label: 'Pakistan' },
  { value: 'PW', label: 'Palau' },
  { value: 'PS', label: 'Palestine' },
  { value: 'PG', label: 'Papua New Guinea' },
  { value: 'PY', label: 'Paraguay' },
  { value: 'PE', label: 'Peru' },
  { value: 'PH', label: 'Philippines' },
  { value: 'PT', label: 'Portugal' },
  { value: 'QA', label: 'Qatar' },
  { value: 'RE', label: 'Reunion Island' },
  { value: 'RO', label: 'Romania' },
  { value: 'RU', label: 'Russia' },
  { value: 'RW', label: 'Rwanda' },
  { value: 'SH', label: 'Saint Helena, Ascension And Tristan da Cunha' },
  { value: 'KN', label: 'Saint Kitts And Nevis' },
  { value: 'LC', label: 'Saint Lucia' },
  { value: 'MF', label: 'Saint Martin' },
  { value: 'PM', label: 'Saint Pierre And Miquelon' },
  { value: 'VC', label: 'Saint Vincent And The Grenadines' },
  { value: 'WS', label: 'Samoa' },
  { value: 'SM', label: 'San Marino' },
  { value: 'ST', label: 'Sao Tome And Principe' },
  { value: 'SA', label: 'Saudi Arabia' },
  { value: 'SN', label: 'Senegal' },
  { value: 'SC', label: 'Seychelles' },
  { value: 'SG', label: 'Singapore' },
  { value: 'SX', label: 'Sint Maarten (Dutch Part)' },
  { value: 'SB', label: 'Solomon Islands' },
  { value: 'SO', label: 'Somalia' },
  { value: 'ZA', label: 'South Africa' },
  { value: 'GS', label: 'South Georgia And The South Sandwich Islands' },
  { value: 'KP', label: 'South Korea' },
  { value: 'SS', label: 'South Sudan' },
  { value: 'ES', label: 'Spain' },
  { value: 'LK', label: 'SriLanka' },
  { value: 'SJ', label: 'Svalbard And Jan Mayen Islands' },
  { value: 'SZ', label: 'Swaziland' },
  { value: 'SE', label: 'Sweden' },
  { value: 'CH', label: 'Switzerland' },
  { value: 'SY', label: 'Syria' },
  { value: 'TJ', label: 'Tajikistan' },
  { value: 'TZ', label: 'Tanzania' },
  { value: 'TH', label: 'Thailand' },
  { value: 'TL', label: 'Timor-Leste' },
  { value: 'TG', label: 'Togo' },
  { value: 'TO', label: 'Tonga' },
  { value: 'TT', label: 'Trinidad And Tobago' },
  { value: 'TN', label: 'Tunisia' },
  { value: 'TR', label: 'Turkey' },
  { value: 'TM', label: 'Turkmenistan' },
  { value: 'TC', label: 'Turks And Caicos Islands' },
  { value: 'TV', label: 'Tuvalu' },
  { value: 'UG', label: 'Uganda' },
  { value: 'AE', label: 'United Arab Emirates' },
  { value: 'GB', label: 'United Kingdom' },
  { value: 'UM', label: 'United States Minor Outlying Islands' },
  { value: 'UZ', label: 'Uzbekistan' },
  { value: 'VU', label: 'Vanuatu' },
  { value: 'VA', label: 'Vatican City State' },
  { value: 'VG', label: 'Virgin Islands, British' },
  { value: 'VI', label: 'Virgin Islands, U.S.' },
  { value: 'WF', label: 'Wallis And Futuna' },
  { value: 'EH', label: 'Western Sahara' },
  { value: 'ZM', label: 'Zambia' },
  { value: 'ZW', label: 'Zimbabwe' },
  { value: 'AL', label: 'Albania' },
  { value: 'AS', label: 'American Samoa' },
  { value: 'BZ', label: 'Belize' },
  { value: 'BO', label: 'Bolivia (Plurinational State of)' },
  { value: 'BN', label: 'Brunei Darussalam [f]' },
  { value: 'CA', label: 'Canada' },
  { value: 'CL', label: 'Chile' },
  { value: 'CR', label: 'Costa Rica' },
  { value: 'CI', label: 'Côte d Ivoire' },
  { value: 'IS', label: 'Iceland' },
  { value: 'KZ', label: 'Kazakhstan' },
  { value: 'KR', label: 'Korea (the Republic of)' },
  { value: 'MO', label: 'Macao' },
  { value: 'NE', label: 'Niger' },
  { value: 'PA', label: 'Panama' },
  { value: 'PN', label: 'Pitcairn' },
  { value: 'PL', label: 'Poland' },
  { value: 'PR', label: 'Puerto Rico' },
  { value: 'BL', label: 'Saint Barthélemy' },
  { value: 'RS', label: 'Serbia' },
  { value: 'SL', label: 'Sierra Leone' },
  { value: 'SK', label: 'Slovakia' },
  { value: 'SI', label: 'Slovenia' },
  { value: 'SD', label: 'Sudan' },
  { value: 'SR', label: 'Suriname' },
  { value: 'TK', label: 'Tokelau' },
  { value: 'UA', label: 'Ukraine' },
  { value: 'US', label: 'United States of America' },
  { value: 'UY', label: 'Uruguay' },
  { value: 'VE', label: 'Venezuela' },
  { value: 'VN', label: 'Viet Nam' },
  { value: 'YE', label: 'Yemen' },  
];

export const County_TIN_Limits = {
  IN : {min:10,max:10},
  AF : {min:2,max:10},
  AL : {min:10,max:10},
  AR : {min:11,max:11},
  AD : {min:10,max:10},
  AI : {min:10,max:10},
  AM : {min:8,max:8},
  AW : {min:8,max:8},
  AU : {min:8,max:9},
  AT : {min:11,max:11},
  AZ : {min:10,max:10},
  BB : {min:13,max:13},
  BE : {min:11,max:11},
  BZ : {min:6,max:6},
  BR : {min:14,max:14},
  BN : {min:9,max:9},
  BG : {min:9,max:9},
  CA : {min:9,max:9},
  CL : {min:9,max:10},
  CN : {min:18,max:18},
  CO : {min:13,max:13},
  CK : {min:5,max:5},
  CR : {min:11,max:11},
  HR : {min:11,max:11},
  CW : {min:9,max:9},
  CY : {min:9,max:9},
  CZ : {min:10,max:10},
  DK : {min:11,max:11},
  DM : {min:6,max:6},
  EC : {min:13,max:13},
  EE : {min:11,max:11},
  FO : {min:9,max:9},
  FI : {min:11,max:11},
  FR : {min:13,max:13},
  GE : {min:9,max:9},
  DE : {min:11,max:11},
  GH : {min:11,max:11},
  GI : {min:6,max:6},
  GR : {min:9,max:9},
  GL : {min:10,max:10},
  GD : {min:6,max:6},
  GG : {min:9,max:9},
  HK : {min:11,max:11},
  HU : {min:10,max:10},
  IS : {min:10,max:10},
  ID : {min:20,max:20},
  IE : {min:10,max:10},
  IM : {min:10,max:10},
  IL : {min:9,max:9},
  IT : {min:16,max:16},
  JM : {min:9,max:9},
  JP : {min:12,max:12},
  JE : {min:12,max:12},
  KZ : {min:12,max:12},
  KE : {min:11,max:11},
  KR : {min:14,max:14},
  KW : {min:12,max:12},
  LV : {min:12,max:12},
  LI : {min:12,max:12},
  LT : {min:11,max:11},
  LU : {min:13,max:13},
  MY : {min:11,max:13},
  MV : {min:7,max:7},
  MT : {min:8,max:8},
  MH : {min:9,max:9},
  MU : {min:8,max:8},
  MX : {min:13,max:13},
  MD : {min:13,max:13},
  NR : {min:9,max:9},
  NL : {min:9,max:9},
  NZ : {min:10,max:11},
  NO : {min:11,max:11},
  NG : {min:13,max:13},
  OM : {min:7,max:7},
  PK : {min:13,max:13},
  PA : {min:15,max:15},
  PE : {min:11,max:11},
  PL : {min:11,max:11},
  PT : {min:9,max:9},
  QA : {min:10,max:10},
  RO : {min:13,max:13},
  RU : {min:12,max:12},
  LC : {min:6,max:6},
  SM : {min:1,max:1000},
  SA : {min:10,max:10},
  SC : {min:9,max:9},
  SG : {min:9,max:9},
  SK : {min:10,max:10},
  SI : {min:8,max:8},
  ZA : {min:10,max:10},
  ES : {min:9,max:9},
  SE : {min:11,max:11},
  CH : {min:16,max:16},
  TT : {min:10,max:10},
  TR : {min:10,max:10},
  GB : {min:10,max:10},
  UY : {min:10,max:10},
  VU : {min:6,max:6},
  UA : {min:10,max:10},
}

export const TAX_Expemption_Reasons = [
  { value: '01', label: 'Student' },
  { value: '02', label: 'Home-maker' },
  { value: '03', label: 'House-Wife' },
  { value: '04', label: 'Retired' },
  { value: '05', label: 'Diplomat' },
];

export const Address_Type = [
  { value: '1', label: 'Residential or Business' },
  { value: '2', label: 'Residential' },
  { value: '5', label: 'Unspecified' },
  { value: '3', label: 'Business' },
  { value: '4', label: 'Registered Office' },
];

export const Income_Range = [
  { value: '31', label: 'Below 1 Lac' },
  { value: '32', label: '1-5 Lacs' },
  { value: '33', label: '5-10 Lacs' },
  { value: '34', label: '10-25 Lacs' },
  { value: '35', label: '25 Lacs - 1 Crore' },
  { value: '36', label: 'Above 1 Crore' },
];

export const Source_Of_Wealth = [
  { value: '01', label: 'Salary' },
  { value: '02', label: 'Business Income' },
  { value: '03', label: 'Gift' },
  { value: '04', label: 'Ancestral Property' },
  { value: '05', label: 'Rental Income' },
  { value: '06', label: 'Prize Money' },
  { value: '07', label: 'Royalty' },
  { value: '08', label: 'Others' },
];

export const Occupation = [
  { value: '01', label: 'Business' },
  { value: '02', label: 'Service' },
  { value: '03', label: 'Professional' },
  { value: '04', label: 'Agriculturist' },
  { value: '05', label: 'Retired' },
  { value: '06', label: 'Housewife' },
  { value: '07', label: 'Student' },
  { value: '08', label: 'Others' },
  { value: '09', label: 'Doctor' },
  { value: '41', label: 'Private Sector Service' },
  { value: '42', label: 'Public Sector Service' },
  { value: '43', label: 'Forex Dealer' },
  { value: '44', label: 'Goverment Service' },
  { value: '99', label: 'Unknown/Not Applicable' },
];

export const IndianCities = [
  'Adalaj',
  'Adilabad',
  'Adityapur',
  'Adoni',
  'Adoor',
  'Adra',
  'Adyar',
  'Afzalpur',
  'Agartala',
  'Agra',
  'Ahmedabad',
  'Ahmednagar',
  'Aizawl',
  'Ajmer',
  'Akola',
  'Akot',
  'Alappuzha',
  'Aligarh',
  'Alirajpur',
  'Allahabad',
  'Alwar',
  'Amalapuram',
  'Amalner',
  'Ambejogai',
  'Ambikapur',
  'Amravati',
  'Amreli',
  'Amritsar',
  'Amroha',
  'Anakapalle',
  'Anand',
  'Anantapur',
  'Anantnag',
  'Anjangaon',
  'Anjar',
  'Ankleshwar',
  'Arakkonam',
  'Arambagh',
  'Araria',
  'Arrah',
  'Arsikere',
  'Aruppukkottai',
  'Arvi',
  'Arwal',
  'Asansol',
  'Asarganj',
  'Ashok Nagar',
  'Athni',
  'Attingal',
  'Aurangabad',
  'Aurangabad',
  'Azamgarh',
  'Bagaha',
  'Bageshwar',
  'Bahadurgarh',
  'Baharampur',
  'Bahraich',
  'Balaghat',
  'Balangir',
  'Baleshwar Town',
  'Ballari',
  'Balurghat',
  'Bankura',
  'Bapatla',
  'Baramula',
  'Barbil',
  'Bargarh',
  'Barh',
  'Barmer',
  'Barnala',
  'Barpeta',
  'Batala',
  'Bathinda',
  'Begusarai',
  'Belagavi',
  'Bellampalle',
  'Belonia',
  'Bengaluru',
  'Bettiah',
  'Bhadrachalam',
  'Bhadrak',
  'Bhagalpur',
  'Bhainsa',
  'Bharatpur',
  'Bharuch',
  'Bhatapara',
  'Bhavnagar',
  'Bhawanipatna',
  'Bheemunipatnam',
  'Bhilai Nagar',
  'Bhilwara',
  'Bhimavaram',
  'Bhiwandi',
  'Bhiwani',
  'Bhongir',
  'Bhopal',
  'Bhubaneswar',
  'Bhuj',
  'Bikaner',
  'Bilaspur',
  'Bobbili',
  'Bodhan',
  'Bongaigaon City',
  'Brahmapur',
  'Buxar',
  'Byasanagar',
  'Chaibasa',
  'Chalakudy',
  'Chandausi',
  'Chandigarh',
  'Changanassery',
  'CharkhiDadri',
  'Chatra',
  'Chennai',
  'Cherthala',
  'Chhapra',
  'Chhapra',
  'Chikkamagaluru',
  'Chilakaluripet',
  'Chirala',
  'Chirkunda',
  'Chirmiri',
  'Chittoor',
  'Chittur-Thathamangalam',
  'Coimbatore',
  'Cuttack',
  'Dalli-Rajhara',
  'Darbhanga',
  'Darjiling',
  'Davanagere',
  'Deesa',
  'Dehradun',
  'Dehri-on-Sone',
  'Delhi',
  'Deoghar',
  'Dhamtari',
  'Dhanbad',
  'Dharmanagar',
  'Dharmavaram',
  'Dhenkanal',
  'Dhoraji',
  'Dhubri',
  'Dhule',
  'Dhuri',
  'Dibrugarh',
  'Dimapur',
  'Diphu',
  'Dumka',
  'Dumraon',
  'Durg',
  'Eluru',
  'English Bazar',
  'Erode',
  'Etawah',
  'Faridabad',
  'Faridkot',
  'Farooqnagar',
  'Fatehabad',
  'Fatehpur',
  'Sikri',
  'Fazilka',
  'Firozabad',
  'Firozpur',
  'FirozpurCantt.',
  'Forbesganj',
  'Gadwal',
  'Gangarampur',
  'Ganjbasoda',
  'Gaya',
  'Giridih',
  'Goalpara',
  'Gobichettipalayam',
  'Gobindgarh',
  'Godhra',
  'Gohana',
  'Gokak',
  'Gooty',
  'Gopalganj',
  'Gudivada',
  'Gudur',
  'Gumia',
  'Guntakal',
  'Guntur',
  'Gurdaspur',
  'Gurgaon',
  'Guruvayoor',
  'Guwahati',
  'Gwalior',
  'Habra',
  'Hajipur',
  'Haldwani-cum-Kathgodam',
  'Hansi',
  'Hapur',
  'Hardoi',
  'Hardwar',
  'Hazaribag',
  'Hindupur',
  'Hisar',
  'Hoshiarpur',
  'Hubli-Dharwad',
  'Hugli-Chinsurah',
  'Hyderabad',
  'Ichalkaranji',
  'Imphal',
  'Indore',
  'Itarsi',
  'Jabalpur',
  'Jagdalpur',
  'Jaggaiahpet',
  'Jagraon',
  'Jagtial',
  'Jaipur',
  'Jalandhar',
  'JalandharCantt.',
  'Jalpaiguri',
  'Jamalpur',
  'Jammalamadugu',
  'Jammu',
  'Jamnagar',
  'Jamshedpur',
  'Jamui',
  'Jangaon',
  'Jatani',
  'Jehanabad',
  'Jhansi',
  'Jhargram',
  'Jharsuguda',
  'JhumriTilaiya',
  'Jind',
  'Jodhpur',
  'Jorhat',
  'Kadapa',
  'Kadi',
  'Kadiri',
  'Kagaznagar',
  'Kailasahar',
  'Kaithal',
  'Kakinada',
  'Kalimpong',
  'Kalpi',
  'Kalyan-Dombivali',
  'Kamareddy',
  'Kancheepuram',
  'Kandukur',
  'Kanhangad',
  'Kannur',
  'Kanpur',
  'Kapadvanj',
  'Kapurthala',
  'Karaikal',
  'Karimganj',
  'Karimnagar',
  'Karjat',
  'Karnal',
  'Karur',
  'Karwar',
  'Kasaragod',
  'Kashipur',
  'Katihar',
  'Kavali',
  'Kayamkulam',
  'Kendrapara',
  'Kendujhar',
  'Keshod',
  'Khair',
  'Khambhat',
  'Khammam',
  'Khanna',
  'Kharagpur',
  'Kharar',
  'Khowai',
  'Kishanganj',
  'Kochi',
  'Kodungallur',
  'Kohima',
  'Kolar',
  'Kolkata',
  'Kollam',
  'Koratla',
  'Korba',
  'KotKapura',
  'Kothagudem',
  'Kottayam',
  'Kovvur',
  'Koyilandy',
  'Kozhikode',
  'Kunnamkulam',
  'Kurnool',
  'Kyathampalle',
  'Lachhmangarh',
  'Ladnu',
  'Ladwa',
  'Lahar',
  'Laharpur',
  'Lakheri',
  'Lakhimpur',
  'Lakhisarai',
  'Lakshmeshwar',
  'Lalganj',
  'Lalganj',
  'Lalgudi',
  'Lalitpur',
  'Lalsot',
  'Lanka',
  'Lar',
  'Lathi',
  'Latur',
  'Lilong',
  'Limbdi',
  'Lingsugur',
  'Loha',
  'Lohardaga',
  'Lonar',
  'Lonavla',
  'Longowal',
  'Loni',
  'Losal',
  'Lucknow',
  'Ludhiana',
  'Lumding',
  'Lunawada',
  'Lunglei',
  'Macherla',
  'Machilipatnam',
  'Madanapalle',
  'Maddur',
  'Madhepura',
  'Madhubani',
  'Madhugiri',
  'Madhupur',
  'Madikeri',
  'Madurai',
  'Magadi',
  'Mahad',
  'Mahalingapura',
  'Maharajganj',
  'Maharajpur',
  'Mahasamund',
  'Mahbubnagar',
  'Mahe',
  'Mahemdabad',
  'Mahendragarh',
  'Mahesana',
  'Mahidpur',
  'Mahnar Bazar',
  'Mahuva',
  'Maihar',
  'Mainaguri',
  'Makhdumpur',
  'Makrana',
  'Malaj Khand',
  'Malappuram',
  'Malavalli',
  'Malda',
  'Malegaon',
  'Malerkotla',
  'Malkangiri',
  'Malkapur',
  'Malout',
  'Malpura',
  'Malur',
  'Manachanallur',
  'Manasa',
  'Manavadar',
  'Manawar',
  'Mancherial',
  'Mandalgarh',
  'Mandamarri',
  'Mandapeta',
  'Mandawa',
  'Mandi',
  'Mandi Dabwali',
  'Mandideep',
  'Mandla',
  'Mandsaur',
  'Mandvi',
  'Mandya',
  'Manendragarh',
  'Maner',
  'Mangaldoi',
  'Mangaluru',
  'Mangalvedhe',
  'Manglaur',
  'Mangrol',
  'Mangrol',
  'Mangrulpir',
  'Manihari',
  'Manjlegaon',
  'Mankachar',
  'Manmad',
  'Mansa',
  'Manuguru',
  'Manvi',
  'Manwath',
  'Mapusa',
  'Margao',
  'Margherita',
  'Marhaura',
  'Mariani',
  'Marigaon',
  'Markapur',
  'Marmagao',
  'Masaurhi',
  'Mathabhanga',
  'Mathura',
  'Mattannur',
  'Mauganj',
  'Mavelikkara',
  'Mavoor',
  'Mayang Imphal',
  'Medak',
  'Medininagar (Daltonganj)',
  'Medinipur',
  'Meerut',
  'Mehkar',
  'Memari',
  'Merta City',
  'Mhaswad',
  'Mhow Cantonment',
  'Mhowgaon',
  'Mihijam',
  'Mira-Bhayandar',
  'Mirganj',
  'Miryalaguda',
  'Modasa',
  'Modinagar',
  'Moga',
  'Mohali',
  'Mokameh',
  'Mokokchung',
  'Monoharpur',
  'Moradabad',
  'Morena',
  'Morinda',
  'Morshi',
  'Morvi',
  'Motihari',
  'Motipur',
  'MountAbu',
  'Mudabidri',
  'Mudalagi',
  'Muddebihal',
  'Mudhol',
  'Mukerian',
  'Mukhed',
  'Muktsar',
  'Mulbagal',
  'Multai',
  'Mumbai',
  'Mundargi',
  'Mundi',
  'Mungeli',
  'Munger',
  'Murliganj',
  'Murshidabad',
  'Murtijapur',
  'Murwara(Katni)',
  'Musabani',
  'Mussoorie',
  'Muvattupuzha',
  'Muzaffarpur',
  'Mysore',
  'Nabadwip',
  'Nabarangapur',
  'Nabha',
  'Nadbai',
  'Nadiad',
  'Nagaon',
  'Nagapattinam',
  'Nagar',
  'Nagari',
  'Nagarkurnool',
  'Nagaur',
  'Nagda',
  'Nagercoil',
  'Nagina',
  'Nagla',
  'Nagpur',
  'Nahan',
  'Naharlagun',
  'Naidupet',
  'Naihati',
  'NailaJanjgir',
  'Nainital',
  'Nainpur',
  'Najibabad',
  'Nakodar',
  'Nakur',
  'Nalbari',
  'Namagiripettai',
  'Namakkal',
  'Nanded-Waghala',
  'Nandgaon',
  'Nandivaram-Guduvancheri',
  'Nandura',
  'Nandurbar',
  'Nandyal',
  'Nangal',
  'Nanjangud',
  'Nanjikottai',
  'Nanpara',
  'Narasapuram',
  'Narasaraopet',
  'Naraura',
  'Narayanpet',
  'Nargund',
  'Narkatiaganj',
  'Narkhed',
  'Narnaul',
  'Narsinghgarh',
  'Narsinghgarh',
  'Narsipatnam',
  'Narwana',
  'Nashik',
  'Nasirabad',
  'Natham',
  'Nathdwara',
  'Naugachhia',
  'Nautanwa',
  'Navalgund',
  'Navsari',
  'Nawabganj',
  'Nawada',
  'Nawanshahr',
  'Nawapur',
  'Nedumangad',
  'Neem-Ka-Thana',
  'Neemuch',
  'Nehtaur',
  'Nelamangala',
  'Nellikuppam',
  'Nellore',
  'Nepanagar',
  'New Delhi',
  'Neyveli (TS)',
  'Neyyattinkara',
  'Nidadavole',
  'Nilambur',
  'Nilanga',
  'Nimbahera',
  'Nirmal',
  'Niwai',
  'Niwari',
  'Nizamabad',
  'Nohar',
  'Noida',
  'Nokha',
  'Nokha',
  'Nongstoin',
  'Noorpur',
  'North Lakhimpur',
  'Nowgong',
  'Nuzvid',
  'Valley',
  'Obra',
  'Oddanchatram',
  'Ongole',
  'Orai',
  'Osmanabad',
  'Ottappalam',
  'Ozar',
  'P.N.Patti',
  'Pachora',
  'Pachore',
  'Pacode',
  'Padmanabhapuram',
  'Padra',
  'Padrauna',
  'Paithan',
  'Pakaur',
  'Palacole',
  'Palai',
  'Palakkad',
  'Palampur',
  'Palani',
  'Palanpur',
  'Palghar',
  'Pali',
  'Pali',
  'PaliaKalan',
  'Palitana',
  'Palladam',
  'Pallapatti',
  'Pallikonda',
  'Palwal',
  'Palwancha',
  'Panagar',
  'Panagudi',
  'Panaji',
  'Panamattom',
  'Panchkula',
  'Panchla',
  'Pandharkaoda',
  'Pandharpur',
  'Pandhurna',
  'Panipat',
  'Panna',
  'Panniyannur',
  'Panruti',
  'Panvel',
  'Pappinisseri',
  'Paradip',
  'Paramakudi',
  'Parangipettai',
  'Parasi',
  'Paravoor',
  'Parbhani',
  'Pardi',
  'Parlakhemundi',
  'Parli',
  'Partur',
  'Parvathipuram',
  'Pasan',
  'Pasighat',
  'Patan',
  'Pathanamthitta',
  'Pathankot',
  'Pathardi',
  'Pathri',
  'Patiala',
  'Patna',
  'Patratu',
  'Pattamundai',
  'Patti',
  'Pattran',
  'Pattukkottai',
  'Patur',
  'Pauni',
  'Pauri',
  'Pavagada',
  'Pedana',
  'Peddapuram',
  'Pehowa',
  'Pen',
  'Perambalur',
  'Peravurani',
  'Peringathur',
  'Perinthalmanna',
  'Periyakulam',
  'Periyasemur',
  'Pernampattu',
  'Perumbavoor',
  'Petlad',
  'Phagwara',
  'Phalodi',
  'Phaltan',
  'Phillaur',
  'Phulabani',
  'Phulera',
  'Phulpur',
  'Phusro',
  'Pihani',
  'Pilani',
  'Pilibanga',
  'Pilibhit',
  'Pilkhuwa',
  'Pindwara',
  'Pinjore',
  'Pipariya',
  'Piriyapatna',
  'Piro',
  'Pithampur',
  'Pithapuram',
  'Pithoragarh',
  'Pollachi',
  'Polur',
  'Pondicherry',
  'Ponnani',
  'Ponneri',
  'Ponnur',
  'Porbandar',
  'Porsa',
  'Powayan',
  'Prantij',
  'Pratapgarh',
  'Pratapgarh',
  'Prithvipur',
  'Proddatur',
  'Pudukkottai',
  'Pudupattinam',
  'Pukhrayan',
  'Pulgaon',
  'Puliyankudi',
  'Punalur',
  'Punch',
  'Pune',
  'Punganur',
  'Punjaipugalur',
  'Puranpur',
  'Puri',
  'Purna',
  'Purnia',
  'PurqUrban Agglomerationzi',
  'Purulia',
  'Purwa',
  'Pusad',
  'Puthuppally',
  'Puttur',
  'Puttur',
  'Qadian',
  'Raayachuru',
  'Rabkavi Banhatti',
  'Radhanpur',
  'RaeBareli',
  'Rafiganj',
  'Raghogarh-Vijaypur',
  'Raghunathganj',
  'Raghunathpur',
  'Rahatgarh',
  'Rahuri',
  'Raiganj',
  'Raigarh',
  'Raikot',
  'Raipur',
  'Rairangpur',
  'Raisen',
  'Raisinghnagar',
  'Rajagangapur',
  'Rajahmundry',
  'Rajakhera',
  'Rajaldesar',
  'Rajam',
  'Rajampet',
  'Rajapalayam',
  'Rajauri',
  'Rajgarh',
  'Rajgarh (Alwar)',
  'Rajgarh (Churu)',
  'Rajgir',
  'Rajkot',
  'Rajnandgaon',
  'Rajpipla',
  'Rajpura',
  'Rajsamand',
  'Rajula',
  'Rajura',
  'Ramachandrapuram',
  'Ramagundam',
  'Ramanagaram',
  'Ramanathapuram',
  'Ramdurg',
  'Rameshwaram',
  'RamganjMandi',
  'Ramgarh',
  'Ramnagar',
  'Ramnagar',
  'Ramngarh',
  'Rampur',
  'Rampur Maniharan',
  'RampuraPhul',
  'Rampurhat',
  'Ramtek',
  'Ranaghat',
  'Ranavav',
  'Ranchi',
  'Ranebennuru',
  'Rangia',
  'Rania',
  'Ranibennur',
  'Ranipet',
  'Rapar',
  'Rasipuram',
  'Rasra',
  'Ratangarh',
  'Rath',
  'Ratia',
  'Ratlam',
  'Ratnagiri',
  'Rau',
  'Raurkela',
  'Raver',
  'Rawatbhata',
  'Rawatsar',
  'RaxaulBazar',
  'Rayachoti',
  'Rayadurg',
  'Rayagada',
  'Reengus',
  'Rehli',
  'Renigunta',
  'Renukoot',
  'Reoti',
  'Repalle',
  'Revelganj',
  'Rewa',
  'Rewari',
  'Rishikesh',
  'Risod',
  'Robertsganj',
  'RobertsonPet',
  'Rohtak',
  'Ron',
  'Roorkee',
  'Rosera',
  'Rudauli',
  'Rudrapur',
  'Rudrapur',
  'Rupnagar',
  'Sabalgarh',
  'Sadabad',
  'Sadalagi',
  'Sadasivpet',
  'Sadri',
  'Sadulpur',
  'Sadulshahar',
  'Safidon',
  'Safipur',
  'Sagar',
  'Sagara',
  'Sagwara',
  'Saharanpur',
  'Saharsa',
  'Sahaspur',
  'Sahaswan',
  'Sahawar',
  'Sahibganj',
  'Sahjanwa',
  'Saidpur',
  'Saiha',
  'Sailu',
  'Sainthia',
  'Sakaleshapura',
  'Sakti',
  'Salaya',
  'Salem',
  'Salur',
  'Samalkha',
  'Samalkot',
  'Samana',
  'Samastipur',
  'Sambalpur',
  'Sambhal',
  'Sambhar',
  'Samdhan',
  'Samthar',
  'Sanand',
  'Sanawad',
  'Sanchore',
  'Sandi',
  'Sandila',
  'Sanduru',
  'Sangamner',
  'Sangareddy',
  'Sangaria',
  'Sangli',
  'Sangole',
  'Sangrur',
  'Sankarankovil',
  'Sankari',
  'Sankeshwara',
  'Santipur',
  'Sarangpur',
  'Sardarshahar',
  'Sardhana',
  'Sarni',
  'Sarsod',
  'Sasaram',
  'Sasvad',
  'Satana',
  'Satara',
  'Sathyamangalam',
  'Achalpur',
  'Satna',
  'Sattenapalle',
  'Sattur',
  'Saunda',
  'Saundatti-Yellamma',
  'Sausar',
  'Savanur',
  'Savarkundla',
  'Savner',
  'SawaiMadhopur',
  'Sawantwadi',
  'Sedam',
  'Sehore',
  'Sendhwa',
  'Seohara',
  'Seoni',
  'Seoni-Malwa',
  'Shahabad',
  'Shahabad',
  'Shahabad',
  'Shahade',
  'Shahbad',
  'Shahdol',
  'Shahganj',
  'Shahjahanpur',
  'Shahpur',
  'Shahpura',
  'Shahpura',
  'Shajapur',
  'Shamgarh',
  'Shamli',
  'Shamsabad',
  'Shamsabad',
  'Shegaon',
  'Sheikhpura',
  'Shendurjana',
  'Shenkottai',
  'Sheoganj',
  'Sheohar',
  'Sheopur',
  'Sherghati',
  'Sherkot',
  'Shiggaon',
  'Shikaripur',
  'Shikarpur',
  'Shikohabad',
  'Shillong',
  'Shimla',
  'Shirdi',
  'Shirpur-Warwade',
  'Shirur',
  'Shishgarh',
  'Shivamogga',
  'Shivpuri',
  'Sholavandan',
  'Sholingur',
  'Shoranur',
  'Shrigonda',
  'Shrirampur',
  'Shrirangapattana',
  'Shujalpur',
  'Siana',
  'Sibsagar',
  'Siddipet',
  'Sidhi',
  'Sidhpur',
  'Sidlaghatta',
  'Sihor',
  'Sihora',
  'Sikanderpur',
  'SikandraRao',
  'Sikandrabad',
  'Sikar',
  'Silao',
  'Silapathar',
  'Silchar',
  'Siliguri',
  'Sillod',
  'Silvassa',
  'Simdega',
  'Sindagi',
  'Sindhagi',
  'Sindhnur',
  'Singrauli',
  'Sinnar',
  'Sira',
  'Sircilla',
  'Sirkali',
  'Sirohi',
  'Sironj',
  'Sirsa',
  'Sirsaganj',
  'Sirsi',
  'Sirsi',
  'Siruguppa',
  'Sitamarhi',
  'Sitapur',
  'Sitarganj',
  'Sivaganga',
  'Sivagiri',
  'Sivakasi',
  'Siwan',
  'Sohagpur',
  'Sohna',
  'Sojat',
  'Solan',
  'Solapur',
  'Sonamukhi',
  'Sonepur',
  'Songadh',
  'Sonipat',
  'Sopore',
  'Soro',
  'Soron',
  'Soyagaon',
  'SriMadhopur',
  'Srikakulam',
  'Srikalahasti',
  'Srinagar',
  'Srinagar',
  'Srinivaspur',
  'Srirampore',
  'Srivilliputhur',
  'Sugauli',
  'Sujangarh',
  'Sujanpur',
  'Sullurpeta',
  'Sultanganj',
  'Sultanpur',
  'Sumerpur',
  'Sumerpur',
  'Sunabeda',
  'Sunam',
  'Sundargarh',
  'Sundarnagar',
  'Supaul',
  'Surandai',
  'Surapura',
  'Surat',
  'Suratgarh',
  'SUrban Agglomerationr',
  'Suri',
  'Suriyampalayam',
  'Suryapet',
  'Tadepalligudem',
  'Tadpatri',
  'Takhatgarh',
  'Talaja',
  'Talcher',
  'Talegaon Dabhade',
  'Talikota',
  'Taliparamba',
  'Talode',
  'Talwara',
  'Tamluk',
  'Tanda',
  'Tandur',
  'Tanuku',
  'Tarakeswar',
  'Tarana',
  'Taranagar',
  'Taraori',
  'Tarbha',
  'Tarikere',
  'Tasgaon',
  'Tehri',
  'Tekkalakote',
  'Tenali',
  'Tenkasi',
  'Terdal',
  'Tezpur',
  'Thakurdwara',
  'Thammampatti',
  'ThanaBhawan',
  'Thane',
  'Thanesar',
  'Thangadh',
  'Thanjavur',
  'Tharad',
  'Tharamangalam',
  'Tharangambadi',
  'Thirumangalam',
  'Thirupuvanam',
  'Thiruthuraipoondi',
  'Thiruvalla',
  'Thiruvallur',
  'Thiruvananthapuram',
  'Thiruvarur',
  'Thodupuzha',
  'Thoubal',
  'Thrissur',
  'Thuraiyur',
  'Tikamgarh',
  'TildaNewra',
  'Tilhar',
  'Tindivanam',
  'Tinsukia',
  'Tiptur',
  'Tirora',
  'Tiruchendur',
  'Tiruchengode',
  'Tiruchirappalli',
  'Tirukalukundram',
  'Tirukkoyilur',
  'Tirunelveli',
  'Tirupathur',
  'Tirupathur',
  'Tirupati',
  'Tiruppur',
  'Tirur',
  'Tiruttani',
  'Tiruvannamalai',
  'Tiruvethipuram',
  'Tiruvuru',
  'Tirwaganj',
  'Titlagarh',
  'Tittakudi',
  'Todabhim',
  'Todaraisingh',
  'Tohana',
  'Tonk',
  'Tuensang',
  'Tuljapur',
  'Tulsipur',
  'Tumkur',
  'Tumsar',
  'Tundla',
  'Tuni',
  'Tura',
  'Uchgaon',
  'Udaipur',
  'Udaipur',
  'Udaipurwati',
  'Udgir',
  'Udhagamandalam',
  'Udhampur',
  'Udumalaipettai',
  'Udupi',
  'Ujhani',
  'Ujjain',
  'Umarga',
  'Umaria',
  'Umarkhed',
  'Umbergaon',
  'Umred',
  'Umreth',
  'Una',
  'Unjha',
  'Unnamalaikadai',
  'Unnao',
  'Upleta',
  'Uran',
  'Uran Islampur',
  'Uravakonda',
  'UrmarTanda',
  'Usilampatti',
  'Uthamapalayam',
  'Uthiramerur',
  'Utraula',
  'Vadakkuvalliyur',
  'Vadalur',
  'Vadgaon Kasba',
  'Vadipatti',
  'Vadnagar',
  'Vadodara',
  'Vaijapur',
  'Vaikom',
  'Valparai',
  'Valsad',
  'Vandavasi',
  'Vaniyambadi',
  'Varanasi',
  'Varkala',
  'Vasai-Virar',
  'Vatakara',
  'Vedaranyam',
  'Vellakoil',
  'Vellore',
  'Venkatagiri',
  'Veraval',
  'Vidisha',
  'Vijainagar',
  'Vijapur',
  'Vijayapura',
  'Vijayawada',
  'Vijaypur',
  'Vikarabad',
  'Vikramasingapuram',
  'Viluppuram',
  'Vinukonda',
  'Viramgam',
  'Virudhachalam',
  'Virudhunagar',
  'Visakhapatnam',
  'Visnagar',
  'Viswanatham',
  'Vita',
  'Vizianagaram',
  'Vrindavan',
  'Vyara',
  'Wadgaon Road',
  'Wadhwan',
  'Wadi',
  'Wai',
  'Wanaparthy',
  'Wani',
  'Wankaner',
  'Wara Seoni',
  'Warangal',
  'Wardha',
  'Warhapur',
  'Warisaliganj',
  'Warora',
  'Warud',
  'Washim',
  'Wokha',
  'Yadgir',
  'Yamunanagar',
  'Yanam',
  'Yavatmal',
  'Yawal',
  'Yellandu',
  'Yemmiganur',
  'Yerraguntla',
  'Yevla',
  'Zaidpur',
  'Zamania',
  'Zira',
  'Zirakpur',
  'Zunheboto',
];
